export default __webpack_public_path__ + "3e4b219b646b6c1a7c7942bdeaee00f6.webp";